import React from "react"
import ContentCopyComponent from "./ContentCopy"
import contentFactory from "./contentcopy.factory"

export const ContentCopy = props => {
  const { data } = props
  const componentProps = { ...props, ...contentFactory.transform(data) }
  return <ContentCopyComponent {...componentProps} />
}

export default ContentCopy
